module.exports = __webpack_public_path__ + "media/src/images/icons/linked_items-9e4353d17c782f3c3e0fecf839ffa350.svg";